'use client';

import { ThemeProvider as NextThemesProvider } from 'next-themes';
import type { ReactNode } from 'react';

// Define props for our custom ThemeProvider
interface ThemeProviderProps {
  children: ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  return (
    <NextThemesProvider
      attribute='class'
      forcedTheme='light' // FORCE light theme
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
